import { render, staticRenderFns } from "./tasks-journal.vue?vue&type=template&id=cda80cc4"
import script from "./tasks-journal.vue?vue&type=script&lang=ts"
export * from "./tasks-journal.vue?vue&type=script&lang=ts"
import style0 from "./tasks-journal.vue?vue&type=style&index=0&id=cda80cc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports